/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WorkflowEventTriggerType {
    STATUS_CHANGE = 'StatusChange',
    ACTION_CODE = 'ActionCode',
    OTHER = 'Other',
}
